module.exports = __webpack_public_path__ + "static/images/wzry-title-bg.f697668.png";